import React from 'react';
import PropTypes from 'prop-types';
import './TipoCambio.css';

TipoCambio.propTypes = {
    title:PropTypes.string,
    longDateStr:PropTypes.string,
    curSymbol:PropTypes.string,
    compra:PropTypes.number,
    venta:PropTypes.number,
    tasaBasicaPasiva:PropTypes.number
};

function TipoCambio({
    title="TIPO DE CAMBIO DÓLAR",
    longDateStr="", 
    curSymbol="₡", 
    compra=0.00, 
    venta=0.00, 
    tasaBasicaPasiva=0.00, 
    ...props
}) {
    return (
        <div className='container d-flex flex-wrap justify-content-around p-3'>
            <div className='font-tipo-cambio p-2'>{title}</div>
            <div className='font-tipo-cambio p-2'><strong>{longDateStr}</strong></div>
            <div className='font-tipo-cambio p-2'>COMPRA <strong>{curSymbol}{compra}</strong></div>            
            <div className='font-tipo-cambio p-2'>VENTA <strong>{curSymbol}{venta}</strong></div>            
            <div className='font-tipo-cambio p-2'> TBP <strong>{tasaBasicaPasiva}%</strong></div>
        </div>
    );
}

export default TipoCambio;